import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.0.10_@babel+core@7.28.5_@playwright+test@1.57.0_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.0.10_@babel+core@7.28.5_@playwright+test@1.57.0_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["GoBackButton"] */ "/app/src/components/ui/StatusPage/GoBackButton.tsx");
